module.exports = __webpack_public_path__ + "static/img/202.9639b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/202.jpg
// module id = 6OXK
// module chunks = 0